/**
 * api接口的统一出口
 */
import userInfo from "@/request/api/userInfo";
import pay from "@/request/api/pay";

// 导出接口
export default {
  userInfo,
  pay
}
